<template>
  <div class="login-popup">
    <button class="login-popup_btn" @click="popup_login = !popup_login">ログイン</button>
    <transition name="login-popup">
      <div class="login-popup_popup_wrapper" v-if="popup_login" @click="popup_login = !popup_login">
        <div class="login-popup_popup">
          <p class="login-popup_title">100maiにログイン</p>
          <button class="login_btn twitter" @click="login('twitter')"><i class="fab fa-twitter"></i><p>Twitterでログイン</p></button>
          <button class="login_btn google" @click="login('google')"><i class="fab fa-google"></i><p>Googleでログイン</p></button>
          <!-- <button class="login_btn mail"><i class="fas fa-envelope"></i><p>メールアドレスでログイン</p></button> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import firebaseUtil from '@/firebase.js';

export default {
  data() {
    return {
      popup_login: false,
    };
  },
  methods: {
    login(provider) {
      if(provider == 'twitter') {
        firebaseUtil.T_login();
      } else if(provider == 'google') {
        firebaseUtil.G_login();
      }
    }
  }
}
</script>

<style lang="scss">
  .login-popup-enter-active,
  .login-popup-leave-active {
    transition: opacity 0.3s;
  }
  .login-popup-enter,
  .login-popup-leave-to {
    opacity: 0;
  }
  .login-popup {
    &_btn {
      margin-right: 20px;
      @include fz(18);
      height: 40px;
      padding: 0 20px;
      border-radius: 20px;
      border: 2px solid $main_orange;
      @include flex_c;
      background-color: #fff;
      color: $main_orange;
      transition: .3s;
      @include text_overflow(1);
      @include pc {
        &:hover {
          background-color: $main_orange;
          color: #fff;
        }
      }
    }
    &_title {
      font-weight: 500;
      text-align: center;
      padding: 10px;
      background-color: $main_orange;
      color: #fff;
      margin-bottom: 20px;
    }
    &_popup {
      @include popup();
      display: flex;
      flex-direction: column;
      .login_btn {
        @include fz(18);
        margin: 10px 0;
        display: flex;
        align-items: flex-end;
        padding: 4px 0;
        @include pc {
          &:hover {
            i {
              animation: shake .5s normal;
            }
          }
        }
        i {
          @include icon(40px);
          color: #fff;
          margin-right: 10px;
          &.fa-twitter {
            background-color: $twitter;
          }
          &.fa-google {
            background-color: $google;
          }
          &.fa-envelope {
            background-color: $text_gray;
          }
        }
        p {
          font-weight: 500;
          padding: 4px 0;
          margin-right: 10px;
        }
        &.twitter p{
          border-bottom: 4px solid $twitter;
        }
        &.google p{
          border-bottom: 4px solid $google;
        }
        &.mail p{
          border-bottom: 4px solid $text_gray;
        }
        
      }
    }
  }
</style>